import { LocaleString as LocaleStringType } from '__generated__/graphql-sanity';
import { Maybe } from 'utils/types';

export type LinkObjectType = {
  category?: Maybe<LocaleStringType>;
  article?: Maybe<string>;
  marketing?: Maybe<string>;
  support?: Maybe<string>;
  product?: Maybe<string>;
  core?: Maybe<string>;
  absolute?: Maybe<string>;
  newtab?: Maybe<boolean>;
  popup?: Maybe<boolean>;
  query?: Maybe<string>;
  action?: string;
};

export const LinkObject = (field: string) => `
  ${field} {
      ...,
      "category": category -> urls,
      "article": "articles/" + article -> puid.current,
      "marketing": marketing -> url.current,
      "support": support -> url.current,
  }
`;
